<template>
    <div>
        <slot></slot>
        <button
            class="mt-3 btn"
            @click="togglePopup"
            :class="open ? 'btn-white btn-small' : `btn-${buttonStyle}`"
        >
            <span v-if="!open">
                <slot name="button"></slot>
            </span>
            <span v-else>
                Hide Content
            </span>
        </button>

        <transition name="fade">
            <div v-if="open" class="mt-8" ref="content">
                <button
                    @click="hidePopup"
                    class="appearance-none absolute pin-t pin-r mt-2 mr-2 group outline-none focus:shadow-outline p-0"
                >
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        class="w-8 h-8 fill-current"
                        viewBox="0 0 24 24"
                    >
                        <circle
                            cx="12"
                            cy="12"
                            r="10"
                            class="text-grey-lighter group-hover:text-grey-light"
                        ></circle>
                        <path
                            d="M13.41 12l2.83 2.83a1 1 0 0 1-1.41 1.41L12 13.41l-2.83 2.83a1 1 0 1 1-1.41-1.41L10.59 12 7.76 9.17a1 1 0 0 1 1.41-1.41L12 10.59l2.83-2.83a1 1 0 0 1 1.41 1.41L13.41 12z"
                            class="text-grey group-hover:text-grey-dark"
                        ></path>
                    </svg>
                </button>
                <slot name="popup"></slot>
            </div>
        </transition>
    </div>
</template>

<script>
export default {
    props: {
        buttonStyle: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            open: false,
        }
    },
    methods: {
        togglePopup() {
            this.open = !this.open
            if (this.open) {
                this.$nextTick(() => {
                    this.$refs.content.focus()
                })
            }
        },
        showPopup() {
            this.open = true
        },
        hidePopup() {
            this.open = false
        },
    },
}
</script>
<style></style>
